import { Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { LabelValue, Settings, SettingsCartItemOrder } from '../../interfaces/interfaces';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent extends UnsubscribeComponent {

  formGroup: FormGroup = new FormGroup({
    email: new FormGroup({
      contactNotifyAddresses: new FormControl([]),
      registrationNotifyAddresses: new FormControl([]),
      orderNotifyAddresses: new FormControl([]),
      redirectAllEmailsToThisAddress: new FormControl(''),
      senderAddress: new FormControl(''),
      senderIdentity: new FormControl('')
    }),
    socialUrls: new FormGroup({
      facebook: new FormControl(''),
      twitter: new FormControl(''),
      youtube: new FormControl(''),
      pinterest: new FormControl(''),
      instagram: new FormControl(''),
      tumblr: new FormControl('')
    }),
    customers: new FormGroup({
      newCustomerLegalStatus: new FormControl(''),
      activateByEmailValidation: new FormControl(false),
      notifyCustomerAboutActivation: new FormControl(false)
    }),
    defaultLanguage: new FormControl(''),
    defaultDomain: new FormControl(''),
    cartItemOrder: new FormControl('DATE'),
  });

  legalStatuses: LabelValue[] = [
    { label: 'Cég', value: 'COMPANY' },
    { label: 'Magánszemély', value: 'PRIVATE' },
    { label: 'Adószámos magánszemély', value: 'PRIVATE_WITH_TAXNUMBER' }
  ];

  cartItemOrders: LabelValue<SettingsCartItemOrder>[] = [
    { label: 'Hozzáadás ideje', value: SettingsCartItemOrder.DATE },
    { label: 'Termék kódja', value: SettingsCartItemOrder.PRODUCT_CODE },
    { label: 'Termék megnevezése', value: SettingsCartItemOrder.PRODUCT_NAME }
  ];

  constructor(
    private apiServiceRef: ApiService,
    private messageService: MessageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this.apiServiceRef.getSettings().pipe(takeUntil(this.unsubscribe)).subscribe(({settings}) => {
      this.fillForm(settings);
    });
  }

  fillForm(settings: Settings): void {
    this.formGroup.get('email').get('contactNotifyAddresses').setValue(settings.email.contactNotifyAddresses);
    this.formGroup.get('email').get('registrationNotifyAddresses').setValue(settings.email.registrationNotifyAddresses);
    this.formGroup.get('email').get('orderNotifyAddresses').setValue(settings.email.orderNotifyAddresses);
    this.formGroup.get('email').get('redirectAllEmailsToThisAddress').setValue(settings.email.redirectAllEmailsToThisAddress);
    this.formGroup.get('email').get('senderAddress').setValue(settings.email.senderAddress);
    this.formGroup.get('email').get('senderIdentity').setValue(settings.email.senderIdentity);
    this.formGroup.get('socialUrls').get('facebook').setValue(settings.socialUrls.facebook);
    this.formGroup.get('socialUrls').get('twitter').setValue(settings.socialUrls.twitter);
    this.formGroup.get('socialUrls').get('youtube').setValue(settings.socialUrls.youtube);
    this.formGroup.get('socialUrls').get('pinterest').setValue(settings.socialUrls.pinterest);
    this.formGroup.get('socialUrls').get('instagram').setValue(settings.socialUrls.instagram);
    this.formGroup.get('socialUrls').get('tumblr').setValue(settings.socialUrls.tumblr);
    this.formGroup.get('defaultLanguage').setValue(settings.defaultLanguage);
    this.formGroup.get('defaultDomain').setValue(settings.defaultDomain);
    this.formGroup.get('customers').get('newCustomerLegalStatus').setValue(settings.customers.newCustomerLegalStatus);
    this.formGroup.get('customers').get('activateByEmailValidation').setValue(settings.customers.activateByEmailValidation);
    this.formGroup.get('customers').get('notifyCustomerAboutActivation').setValue(settings.customers.notifyCustomerAboutActivation);
    this.formGroup.get('cartItemOrder').setValue(settings.cartItemOrder);
  }

  save(): void {
    const settings: Settings = this.formGroup.value;
    this.apiServiceRef.saveSettings(settings).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Beállítások mentése',
        detail: 'Sikeres mentés'
      });
    });
  }

}
